import { useGetEstimationSchemesQuery } from '@/common/queries/useGetEstimationScheme';
import { commonQueryKeys } from '@/common/queryKeys/common';
import { usePublishedContext } from '@/features/views/components/published/PublishedContext';
import { usePublishedSnapshotQuery } from '@/features/views/components/published/usePublishedSnapshotQuery';

export const useEstimationSchemesQueryWithPublished = ({
  enabled = true,
}: {
  enabled?: boolean;
} = {}) => {
  const publishedContext = usePublishedContext();
  const isPublished = publishedContext !== null;

  const schemesQuery = useGetEstimationSchemesQuery({ enabled: !isPublished && enabled });

  const publishedQuery = usePublishedSnapshotQuery({
    baseKey: commonQueryKeys.estimationSchemes.all(),
    getSnapshot: () => publishedContext?.estimationSchemes,
  });

  return isPublished ? publishedQuery : schemesQuery;
};
